import React from 'react';
import ColorRowHeader from './ColorRowHeader';
import {
  ColorInfoNotAvailable,
} from './styles';

const noAvailableColors = () => (
  <div>
    <ColorRowHeader />
    <ColorInfoNotAvailable>
      Hmm… We currently can’t display available colors in your area. Please check back soon.
    </ColorInfoNotAvailable>
  </div>
);

export default noAvailableColors;
